/* eslint-disable  */
import React, {useEffect, useRef, useState} from 'react';
import clsx from 'clsx';
// @ts-ignore
import {useSwiperSlide} from 'swiper/react';
import {useTypedSelector} from 'store/useTypedSelector';
import Loader from 'components/shared/Loader/Loader';
import CategorySelector from '../CategorySelector';
import styles from './Post.module.scss';
import Video from './Video';
import BottomContent from './BottomContent';
import AppointmentBooking from './AppointmentBooking/AppointmentBooking';
import TopMenuWithSearch from '../TopMenuWithSearch';
import {useActions} from 'store/useActions';
import SignUpNew from 'modules/auth/components/SignUp/New/SignUpNew';
import SignIn from 'modules/auth/components/SignIn';
import {useNavigate} from 'react-router-dom';
import useIsAuth from 'sdk/hooks/useIsAuth';
import supabase from 'sdk/api';
import PostBadge from './PostBadge';


const incrementPostView = async (postId: string) => {
    try {
        const {data} = await supabase.rpc('increment_view', {post_id: postId});
    } catch (error) {
        console.error('Failed to increment view', error);
    }
};


function Post(props: any) {
    const {data, targetPostId} = props;

    const postRef = useRef<HTMLDivElement | null>(null)
    const [hasBeenWatched, setHasBeenWatched] = useState<boolean>(false);

    const post = data?.data;
    const className = props?.className;
    const navigate = useNavigate();


    const {data: isAuthData} = useIsAuth();

    const [videoProgressHovered, setVideoProgressHovered] = useState<boolean>(false);
    const swiperSlide = useSwiperSlide();
    const [isSignUpVisible, setSignUpVisible] = useState<boolean>(false);
    const [isSignInVisible, setSignInVisible] = useState<boolean>(false);
    const {isActiveCaptions, isAppointmentBookingOpen} = useTypedSelector(state => state.postSlice);

    const {setIsAppointmentBookingOpen} = useActions();
    const [activeCategoryName, setActiveCategoryName] = useState('');

    const handleVideoProgressHover = (state: boolean) => {
        setVideoProgressHovered(state);
    };

    useEffect(() => {
        if (!post?.id || hasBeenWatched) return;

        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {

                    const timer = setTimeout(() => {
                        incrementPostView(post.id);
                        setHasBeenWatched(true);
                    }, 7000);


                    return () => clearTimeout(timer);
                }
            },
            {
                threshold: 0.9,
            }
        );

        if (postRef.current) {
            observer.observe(postRef.current);
        }

        return () => {
            if (postRef.current) {
                observer.unobserve(postRef.current);
            }
        };
    }, [post?.id, hasBeenWatched]);

    return (
        <div ref={postRef} className={clsx(className, styles.container)}>
            <TopMenuWithSearch/>
            <PostBadge text={(post.sponsored || post.end_date) ? "Sponsored" : null}/>
            {(data || post) && (
                <Video
                    src={post?.video_link}
                    poster={post?.poster}
                    handleVideoMuted={props?.onVideoMuted}
                    isActiveSlide={props.isActive}
                    isNextSlide={swiperSlide.isNext}
                    isPrevSlide={swiperSlide.isPrev}
                    onProgressHover={handleVideoProgressHover}
                    progressHovered={videoProgressHovered}
                    isActiveCaptions={isActiveCaptions}
                    id={post?.id}
                    targetPostId={targetPostId}
                />
            )}
            {!data && !post && !swiperSlide.isActive && <Loader className={styles.loader}/>}
            {post?.tradingPlatform && (
                <div className={styles.tradeInfoContainer}>
                    <div className={styles.tradeInfo}>
                        <img src={post?.tradingPlatform?.logo} alt={post?.tradingPlatform?.name}/>
                        {post?.tradingPlatform?.name}
                    </div>
                </div>
            )}

            {props?.title && (
                <div className={styles.categoryContainer}>
                    <div className={styles.categorySelect}>{props?.title}</div>
                </div>
            )}
            <BottomContent
                setSignUpVisible={setSignUpVisible}
                activeCategoryName={activeCategoryName}
                videoProgressHovered={videoProgressHovered}
                {...props}
                openBooking={() => {
                    if (isAuthData?.isAuth) {
                        navigate(`/appointment-booking/${post?.salon_profile}`);
                    } else {
                        navigate('/sign-up');
                    }
                }}
            />
            {/* <AppointmentBooking salonId={post?.salon_profile} /> */}
        </div>
    );
}

export default Post;
